export default function highlight() {
  return function link(textArg, search) {
    if (search) {
      const text = textArg.toString();
      return text.replace(
        new RegExp(`\\B(${search.toString()})(?=\\W|$)`, 'gi'),
        '<span class="ui-match">$&</span>'
      );
    }

    return textArg;
  };
}
